import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ruta-form',
  templateUrl: './ruta-form.component.html',
  styleUrls: ['./ruta-form.component.css']
})
export class RutaFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
